import "./publication.scss";

import PublicationsCards, {
    formatPublishedAt,
} from "@frontend/js/Components/Site/PublicationsCards/PublicationsCards";
import PageTitleBreadcrumb from "@frontend/js/Components/Shared/PageTitleBreadcrumb/PageTitleBreadcrumb";
import ShareActions from "@frontend/js/Components/Shared/ShareActions/ShareActions";
import ImageLayer from "@frontend/js/Components/Shared/ImageLayer/ImageLayer";
import MetaHead from "@frontend/js/Components/Shared/MetaHead/MetaHead";
import { resolvePreferredLocale } from "@frontend/js/utils/locale";
import SiteLayout from "@frontend/js/Layouts/SiteLayout";
import useT from "@frontend/js/hooks/useT";
import useRoute from "@frontend/js/hooks/useRoute";
import { usePage } from "@inertiajs/react";

export default function Blog({ page, resource, related, meta }) {
    const { props, url } = usePage();
    const { t } = useT("site");
    const route = useRoute();
    const locale = resolvePreferredLocale({
        url,
        currentLocale: props?.currentLocale,
        siteLanguages: props?.siteLanguages,
    });
    const article = resource?.data;
    const currentSlug = url.split("/").filter(Boolean).pop();

    const relatedCards = related?.data || [];
    const filteredRelatedCards = Array.isArray(relatedCards)
        ? relatedCards.filter((card) => card.slug !== currentSlug).slice(0, 3)
        : [];

    return (
        <>
            <MetaHead meta={meta} />

            <SiteLayout>
                <div className="blog page-shell">
                    <PageTitleBreadcrumb
                        title={article?.title?.[locale] || article?.title}
                        variant="large"
                        parentTitle={page?.title?.[locale] || page?.title}
                        parentHref={route("frontend.page", {
                            page: page?.slug,
                        })}
                    />
                    <div className="blog__container">
                        <div className="blog__container__content">
                            {article?.image && (
                                <div className="blog__container__content__image">
                                    <ImageLayer>
                                        <img
                                            src={article.image}
                                            alt={
                                                article?.title?.[locale] ||
                                                article?.title
                                            }
                                            loading="lazy"
                                        />
                                    </ImageLayer>
                                </div>
                            )}
                            <div
                                dangerouslySetInnerHTML={{
                                    __html:
                                        article?.content?.[locale] ||
                                        article?.content,
                                }}
                            />
                        </div>
                        <div className="blog__container__navigation">
                            <div className="blog__container__navigation__meta">
                                <span>
                                    {formatPublishedAt(
                                        article?.publishedAt,
                                        locale,
                                    )}
                                </span>
                                <span>
                                    {article?.readingMinutes?.[locale] ||
                                        article?.readingMinutes}
                                </span>
                            </div>
                            <ShareActions
                                title={t("share-label")}
                                copyLabel={t("copy-link-label")}
                                channels={[
                                    {
                                        id: "facebook",
                                        label: t("facebook-label"),
                                    },
                                    {
                                        id: "twitter",
                                        label: t("twitter-label"),
                                    },
                                    {
                                        id: "linkedin",
                                        label: t("linkedin-label"),
                                    },
                                ]}
                            />
                        </div>
                    </div>
                    {filteredRelatedCards.length > 0 && (
                        <div className="blog__related">
                            <div className="blog__related__container">
                                <h2>{t("related-publications-title")}</h2>
                                <PublicationsCards
                                    cards={filteredRelatedCards}
                                    locale={locale}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </SiteLayout>
        </>
    );
}
